export const INSIGHT_SECTION_CONSTANTS = {
  FAQ: "faqs",
  BLOG: "blogs",
  RESOURCE: "resources",
};
